import axios from "axios"
import { useEffect, useState } from "react"
import Link from "next/link"
import Head from "next/head"
import { debounce } from "@material-ui/core"
import { VenueTile } from "../../modules/miejsca/VenueTile"
import { StatsLinks } from "../../modules/miejsca/widgets/StatsLinks"
import { VenuesMap } from "../../modules/miejsca/widgets/VenuesMap"
import {
  VenuesWrapperStyled,
  VIEW_MODE,
} from "../../modules/miejsca/widgets/VenuesPageWrapper"
import { MojeHeader } from "../header/MojeHeader"
import { LoadingWidget } from "../LoadingWidget"
import { useRouter } from "next/router"
import { Checkbox, Paper, Typography } from "@material-ui/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"

const Page = ({ num, href, current }) => (
  <Link href={href} prefetch={false}>
    <a href={href} className="inline-block">
      <div className={`mx-2 cursor-pointer ${current ? `font-bold` : ""}`}>
        {num}
      </div>
    </a>
  </Link>
)

const Paginator = ({ result, pathPrefix, page }) => {
  if (result?.pageInfo?.pages) {
    const showPages = Math.min(result?.pageInfo?.pages, 20)
    var pages = []
    for (var i = 1; i <= showPages; i++) {
      const link = `${pathPrefix}/${i}`
      pages.push(<Page num={i} href={link} current={page == i} />)
    }
    return (
      <div className="flex flex-row justify-center">
        <div className="my-2">{pages}</div>
      </div>
    )
  }
  return <div />
}

export const VenuesResultsView = ({
  venues,
  loading,
  stats,
  pageMeta = undefined,
  pathPrefix,
  page,
  city,
  category,
  subcategory,
}) => {
  const [viewMode, setViewMode] = useState<any>(VIEW_MODE.BOTH)
  const [hooveredVenue, setHooveredVenue] = useState<any>(undefined)
  const [mapSelectedVenue, setMapSelectedVenue] = useState<any>(undefined)
  const [filterWithMap, setFilterWithMap] = useState(false)
  const [mapBounds, setMapBounds] =
    useState<{
      ne: any
      nw: any
      se: any
      sw: any
    }>()
  const router = useRouter()
  const [mapSearchResult, setMapSearchResult] = useState<any>(undefined)
  const [isDoingMapSearch, setIsDoingMapSearch] = useState(false)

  const handleMouseOverVenue = (venue) => {
    if (hooveredVenue === undefined || hooveredVenue.id != venue.id) {
      setHooveredVenue(venue)
    }
  }

  const handleClickMapCover = () => {
    setViewMode(VIEW_MODE.MAP)
  }

  const handleMapSelectVenue = (venue) => {
    setMapSelectedVenue(venue)
  }
  const handleMouseLeaveVenue = () => {
    setHooveredVenue(undefined)
  }

  const changeBoundsDebounced = debounce((bounds) => {
    console.log("changeBoundsDebounced", bounds)
    setMapBounds(bounds)
    // Update address location
  }, 500)

  const doMapSearch = async (params) => {
    console.log("doMapSearch", params)
    const query = new URLSearchParams(params)
    const url =
      process.env.NEXT_PUBLIC_API_URL + `/public/search?` + query.toString()
    try {
      setIsDoingMapSearch(true)
      const result = await axios.get(url)
      console.log("Result", result)
      if (result.status === 200) {
        setIsDoingMapSearch(false)
        setMapSearchResult(result.data)
      }
    } catch (error) {
      setIsDoingMapSearch(false)
      console.log("Error doing search", error)
    }
  }
  useEffect(() => {
    console.log("Map bounds changed - reload", router, filterWithMap)
    if (mapBounds && filterWithMap) {
      const query = {
        ...router.query,
        ne_lat: mapBounds.ne.lat,
        ne_lng: mapBounds.ne.lng,
        sw_lat: mapBounds.sw.lat,
        sw_lng: mapBounds.sw.lng,
        search_type: "user_map_move",
      }
      const sp = new URLSearchParams(query)
      const root = router.asPath.split("?")[0]
      console.log("root", root)
      const pathname = root + "?" + sp.toString()
      console.log("pathname", pathname)

      // router.push(
      //   {
      //     pathname: "/search",
      //     query,
      //   },
      //   "/search?" + sp.toString()
      // )
      // return

      router.push(
        {
          pathname: router.pathname,
          query,
        },
        pathname,
        { shallow: true }
      )
      doMapSearch(query)
    }
  }, [mapBounds, filterWithMap])

  const handleMapChanged = (position) => {
    console.log("handleMapChanged", position, "filterWithMap: ", filterWithMap)
    if (filterWithMap) {
      changeBoundsDebounced(position.bounds)
    }
  }
  // console.log("VenuesResultsView", venues, pageMeta)
  const items =
    filterWithMap && mapSearchResult?.venues?.items
      ? mapSearchResult.venues?.items
      : (venues?.items ? venues.items : venues) ?? []
  const result =
    filterWithMap && mapSearchResult?.venues ? mapSearchResult?.venues : venues
  var generatedTitle = ""
  if (city && category) {
    generatedTitle = `${subcategory?.name ?? category.name} w miejscowowości ${
      city.name
    }`
  } else if (city) {
    generatedTitle = `Miejsca w miejscowowości ${city.name}`
  } else if (category) {
    generatedTitle = `${subcategory?.name ?? category.name}`
  }

  return (
    <VenuesWrapperStyled viewMode={viewMode}>
      <MojeHeader venueMode showSearch fixed />
      <div></div>
      <div
        className="mapWrapper"
        onClick={() => {
          setViewMode(
            viewMode == VIEW_MODE.MAP ? VIEW_MODE.BOTH : VIEW_MODE.MAP
          )
        }}
      >
        <div className="absolute inset-x-0 top[81px] sm:top-6 z-10 justify-center hidden md:flex">
          <Paper className="flex justify-center items-center px-2">
            <Checkbox
              checked={filterWithMap}
              onChange={(e) => setFilterWithMap(e.target.checked)}
              inputProps={{ "aria-labelledby": "search-using-map" }}
            />
            <Typography component="label" id="search-using-map">
              Szukaj na mapie
            </Typography>
            <div className="w-8 pl-2">
              {isDoingMapSearch && <FontAwesomeIcon icon={faSpinner} spin />}
            </div>
          </Paper>
        </div>
        <VenuesMap
          venues={items}
          hooveredVenue={hooveredVenue}
          onMouseOverVenue={handleMouseOverVenue}
          onMouseLeaveVenue={handleMouseLeaveVenue}
          onSelectVenue={handleMapSelectVenue}
          mapSelectedVenue={mapSelectedVenue}
          onMapChange={handleMapChanged}
          noRecenter={filterWithMap}
        />
        <div className="miniListWrapper">
          <ul className="miniListContent">
            {items &&
              items.map((venue) => (
                <li className="tileWrapper" key={venue.id}>
                  <div className="content">
                    <VenueTile
                      venue={venue}
                      // ref={refs[venue.id]}
                      onMouseOverVenue={handleMouseOverVenue}
                      onMouseLeaveVenue={handleMouseLeaveVenue}
                      selected={
                        hooveredVenue != null && hooveredVenue.id == venue.id
                      }
                      horizontal
                    />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <div className="mapCover" onClick={handleClickMapCover}></div>
      <div className="venuesWrapper">
        {/* This is to limit left column width on wide screens */}
        <div style={{ maxWidth: 752, marginLeft: "auto" }}>
          <div className="handler">
            <div className="handlerContent">
              <div className="handlerTitleWrapper">
                <div className="handlerTitle">
                  {items.length > 0 ? (
                    <span>{items.length} miejsc</span>
                  ) : (
                    <span />
                  )}
                </div>
              </div>
            </div>
          </div>
          <Head>
            <title>{pageMeta?.htmlTitle ?? generatedTitle}</title>
            <meta
              property="og:title"
              content={pageMeta?.htmlTitle ?? generatedTitle}
              key="title"
            />
          </Head>
          {loading && <LoadingWidget fullWidth />}

          {stats && (
            <div
              className=""
              style={{
                gridColumnStart: 1,
                gridColumnEnd: 12,
                padding: "24px 40px 12px",
              }}
            >
              <StatsLinks stats={stats} city={city} category={category} />
            </div>
          )}
          <div className="mt-2">
            <div className="px-8 py-4">
              <h1 className="font-bold text-2xl my-2">
                {pageMeta?.title ?? generatedTitle}{" "}
              </h1>
              <div className="font-normal text-base">
                {pageMeta?.headline &&
                  pageMeta?.headline
                    .split("\n")
                    .map((p) => <p className="mb-2">{p}</p>)}
              </div>
            </div>
          </div>
          {items?.length == 0 && !loading && (
            <>
              <div className="m-4 font-medium text-lg">
                Niestety nie mamy jeszcze żadnych miejsc w tej kategorii.
                Spróbuj inne kategorie i zajrzyj tu za kilka dni.
              </div>
            </>
          )}
          <div className="venuesGrid">
            {items?.map((searchResult) => (
              <VenueTile venue={searchResult} searchResult={searchResult} />
            ))}
          </div>
          <Paginator result={result} pathPrefix={pathPrefix} page={page} />
        </div>
      </div>
    </VenuesWrapperStyled>
  )
}
